import { Tooltip, type TooltipProps, Typography } from '@mui/material'
import React from 'react'
import { Link as RouterLink, type LinkProps } from 'react-router-dom'

import Icon, { type IconProps } from 'components/Icon'
import { type RunStatusLinkProps } from 'components/services/service-route-utils'

export const DEFAULT_DIAGNOSIS_MESSAGE =
  'Reliability Intelligence diagnosis available'
export const DEPENDENCY_OVERVIEW_DIAGNOSIS_MESSAGE =
  'One or more Reliability Intelligence results available'

export const ReliabilityIntelligenceIcon: React.FC<
  Omit<IconProps, 'icon'> & {
    linkProps?: LinkProps
    tooltipProps?: Omit<Partial<TooltipProps>, 'children'>
  }
> = ({ linkProps, tooltipProps = {}, ...iconProps }) => {
  const { title: tooltipTitle, ...tooltipPropsRest } = tooltipProps

  const isLink = Boolean(linkProps?.to)

  return (
    <Tooltip
      arrow
      placement="top"
      title={tooltipTitle ?? ''}
      {...tooltipPropsRest}
    >
      <Typography
        color="marketingViolet650.main"
        component={isLink ? RouterLink : 'span'}
        {...(isLink && linkProps)}
      >
        <Icon
          data-testid="reliability-intelligence-icon"
          icon="regularLightbulbExclamationOn"
          {...iconProps}
        />
      </Typography>
    </Tooltip>
  )
}

export const ReliabilityIntelligenceRunIcon: React.FC<{
  linkProps?: RunStatusLinkProps
}> = ({ linkProps }) => {
  return (
    <ReliabilityIntelligenceIcon
      {...(linkProps?.to && {
        linkProps: {
          ...linkProps,
          // assign true by default, leave alone if caller passes in false
          preventScrollReset: linkProps.preventScrollReset ?? true
        }
      })}
      tooltipProps={{ title: DEFAULT_DIAGNOSIS_MESSAGE }}
    />
  )
}
